import { render, staticRenderFns } from "./rightMenuList.vue?vue&type=template&id=015a91f6&scoped=true"
import script from "./rightMenuList.vue?vue&type=script&lang=js"
export * from "./rightMenuList.vue?vue&type=script&lang=js"
import style0 from "./rightMenuList.vue?vue&type=style&index=0&id=015a91f6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015a91f6",
  null
  
)

export default component.exports